<template>
    <div class="wrapper">
        <parallax class="section page-header header-filter" :style="headerStyle"></parallax>
        <div class="main main-raised">
            <div class="section profile-content">
                <div class="container">
                    <div class="md-layout">
                        <div class="md-layout-item md-size-80 mx-auto">
                            <div class="profile">
                                <div class="avatar">
                                    <img :src="img" alt="Circle Image" class="img-fluid" />
                                </div>
                                <div class="name">
                                    <h2 class="title">No solo es cuestión de color</h2>
                                    <hr />
                                    <h3>Descubre más acerca del albinismo</h3>
                                    <hr />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class=" text-center">
                        <p style="color:black; font-size:1.5rem; line-height:2rem; margin-top:1.3rem;">
                            El albinismo es una condición genética que globalmente se caracteriza por alteraciones importantes en la visión que pueden, o no, aparecer asociadas a la ausencia o disminución de pigmento (melanina) en la piel, los ojos o el pelo.<br />
                            Hay varios tipos de albnismo, pero <b>la única característica que tienen en común es precisamente la visión limitada</b> que presentan.
                        </p>
                    </div>
                    <div class="profile-tabs">
                        <tabs :tab-name="['Archivos', 'Audiolibros', 'Videos']" :tab-icon="['notes', 'headphones', 'camera']" plain nav-pills-icons color-button="success">
                            <!-- here you can add your content for tab-content -->
                            <template slot="tab-pane-1">
                                <div class="md-layout">
                                    <div class="md-layout-item  ml-auto">
                                        <md-list-item style="margin-top:2rem;" href="https://albinismo.es/wp-content/uploads/CuadernoSAnitario.pdf" target="_blank">
                                            <img :src="tabPane1[0].image" class="rounded" alt="pdf1" />
                                            <md-tooltip style="z-index:1050" md-direction="left">Información sanitaria</md-tooltip>
                                        </md-list-item>
                                        <md-list-item href="https://albinismo.es/wp-content/uploads/CuadernoALbinismo3.pdf" target="_blank">
                                            <img :src="tabPane1[1].image" class="rounded" alt="pdf2" />
                                            <md-tooltip style="z-index:1050" md-direction="left">Día a día</md-tooltip>
                                        </md-list-item>
                                    </div>
                                    <div class="md-layout-item  mr-auto">
                                        <md-list-item style="margin-top:2rem;" href="https://albinismo.es/wp-content/uploads/CuadernoEducacion.pdf" target="_blank">
                                            <img :src="tabPane1[3].image" class="rounded" alt="pdf3" />
                                            <md-tooltip style="z-index:1050" md-direction="right">Entorno educativo</md-tooltip>
                                        </md-list-item>
                                        <md-list-item style="margin-top:2rem;" href="http://wwwuser.cnb.csic.es/~albino/queeselalbinismo/indice.html" target="_blank">
                                            <img :src="tabPane1[2].image" class="rounded" alt="pdf4" />
                                            <md-tooltip style="z-index:1050" md-direction="right">¿Qué es el albinismo?</md-tooltip>
                                        </md-list-item>
                                    </div>
                                </div>
                            </template>
                            <template slot="tab-pane-2">
                                <div class="md-layout">
                                    <div class="md-layout-item  ml-auto">
                                        <md-list-item style="margin-top:2rem;" href="https://www.youtube.com/watch?v=et37NXNqHqw" target="_blank">
                                            <img :src="tabPane2[1].image" class="rounded" alt="audiolibro:Qué es el albinismo" />
                                            <md-tooltip style="z-index:1050" md-direction="left">¿Qué es el albinismo?</md-tooltip>
                                        </md-list-item>

                                        <md-list-item href="https://www.youtube.com/watch?v=s8ZdhPBN3Uw" target="_blank">
                                            <img :src="tabPane2[0].image" class="rounded" alt="audiolibro: Tipos de albinisimo" />
                                            <md-tooltip style="z-index:1050" md-direction="left">Tipos de albinismo</md-tooltip>
                                        </md-list-item>
                                    </div>
                                    <div class="md-layout-item  mr-auto">
                                        <md-list-item href="https://www.youtube.com/watch?v=aTULQKsV33o&list=PL1ZnWIFtS5V006yUnImixeA1lkoaGqdLD&index=12" target="_blank">
                                            <img :src="tabPane2[3].image" class="rounded" alt="audiolibro: albinismo oculocutáneo 1" />
                                            <md-tooltip style="z-index:1050" md-direction="right">Albinismo oculocutáneo 1</md-tooltip>
                                        </md-list-item>

                                        <md-list-item href="https://www.youtube.com/watch?v=jnY4iLxPztg&list=PL1ZnWIFtS5V006yUnImixeA1lkoaGqdLD&index=4" target="_blank">
                                            <img :src="tabPane2[2].image" class="rounded" alt="audiolibro: ¿Qué es la melanina?" />
                                            <md-tooltip style="z-index:1050" md-direction="right">¿Qué es la melanina?</md-tooltip>
                                        </md-list-item>
                                    </div>
                                </div>
                            </template>
                            <template slot="tab-pane-3">
                                <div class="md-layout">
                                    <div class="md-layout-item  ml-auto">
                                        <md-list-item style="margin-top:2rem;" href="https://www.youtube.com/watch?v=EcsypTjrehw" target="_blank">
                                            <img :src="tabPane3[1].image" class="rounded" alt="video:albinismo y deporte" />
                                            <md-tooltip style="z-index:1050" md-direction="left">Albinismo y deporte</md-tooltip>
                                        </md-list-item>

                                        <md-list-item href="https://www.youtube.com/watch?v=0aCOV20ewrc" target="_blank">
                                            <img :src="tabPane3[0].image" class="rounded" alt="video: Más allá de su piel" />
                                            <md-tooltip style="z-index:1050" md-direction="left">Más allá de su piel</md-tooltip>
                                        </md-list-item>
                                    </div>
                                    <div class="md-layout-item  mr-auto">
                                        <md-list-item href="https://www.youtube.com/watch?v=dHojY5GhyHQ" target="_blank">
                                            <img :src="tabPane3[3].image" class="rounded" alt="video: rompiendo mitos" />
                                            <md-tooltip style="z-index:1050" md-direction="right">Rompiendo mitos</md-tooltip>
                                        </md-list-item>

                                        <md-list-item href="https://www.youtube.com/watch?v=kguIMobfDJc" target="_blank">
                                            <img :src="tabPane3[2].image" class="rounded" alt="video: ¿Lo ves?" />
                                            <md-tooltip style="z-index:1050" md-direction="right">¿Lo ves?</md-tooltip>
                                        </md-list-item>
                                    </div>
                                </div>
                            </template>
                        </tabs>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Tabs } from "@/components";
export default {
    components: {
        Tabs
    },
    bodyClass: "profile-page",
    data() {
        return {
            tabPane1: [{ image: require("@/assets/img/alb-sanitario.jpg") }, { image: require("@/assets/img/alb-dia.jpg") }, { image: require("@/assets/img/audiolibro.jpg") }, { image: require("@/assets/img/alb-educativo.jpg") }],
            tabPane2: [{ image: require("@/assets/img/tipos.webp") }, { image: require("@/assets/img/albnismo.webp") }, { image: require("@/assets/img/melanina.webp") }, { image: require("@/assets/img/oca.webp") }],
            tabPane3: [{ image: require("@/assets/img/piel.webp") }, { image: require("@/assets/img/deporte.webp") }, { image: require("@/assets/img/loves.webp") }, { image: require("@/assets/img/mitos.webp") }]
        };
    },
    props: {
        header: {
            type: String,
            default: require("@/assets/img/fondo2.png")
        },
        img: {
            type: String,
            default: require("@/assets/img/folders.png")
        }
    },
    computed: {
        headerStyle() {
            return {
                backgroundImage: `url(${this.header})`
            };
        }
    }
};
</script>

<style lang="scss" scoped>
.section {
    padding: 0;
}

.profile-tabs::v-deep {
    .md-card-tabs .md-list {
        justify-content: center;
    }

    [class*="tab-pane-"] {
        margin-top: 3.213rem;
        padding-bottom: 50px;

        img {
            margin-bottom: 2.142rem;
        }
    }
}
</style>
